import React, { useCallback } from "react";
import { useNotify, Loading, fetchStart, fetchEnd } from "react-admin";
import Parse from "parse";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { createMuiTheme } from "@material-ui/core/styles";

import { useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
// import CircularProgress from "@material-ui/core/CircularProgress";
import AppProvider from "../../Components/bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";

import { SelectSlot, MenteeDetails, ConfirmAppointment } from "./steps";
import {
  useSelectedMentees,
  useSelectedSlot,
  useSelectedMentor,
  // useAppointmentData,
  // useZoomMeetingAPI,
  useAppointmentCreator,
} from "./hooks";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    float: "right",
  },
  card: {
    maxWidth: "25vw",
  },
  cardSm: {
    maxWidth: "90vw",
  },
  cardImage: {
    height: "20vh",
    width: "25vw",
  },
  cardImageSm: {
    height: "25vh",
    width: "90vw",
  },

 
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

function getSteps() {
  return ["Select Slot", "Add Mentee Details", "Make Payment"];
}

function getStepContent(step, aid, uid) {
  switch (step) {
    case 0:
      return <SelectSlot aid={aid} />;
    case 1:
      return <MenteeDetails uid={uid} />;
    case 2:
      return <ConfirmAppointment />;
    default:
      return "Unknown step";
  }
}
const mentorTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#EF8354",
    },
  },
});

export default function AppointmentWizard({ aid, uid, mentorDetails, offer }) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();
  const { selectedSlot } = useSelectedSlot();
  const { selectedMentor } = useSelectedMentor();
  const { selectedMentees } = useSelectedMentees();
  const isDesktop = useMediaQuery(mentorTheme.breakpoints.up("md"));
  console.log("offer", offer);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleReset = () => {
    setActiveStep(0);
    selectedMentor({});
    selectedSlot({});
    selectedMentees([]);
  };

  const MakePaymentButton = () => {
    const [open, setOpen] = React.useState(false);
    const [loading, setLoaded] = React.useState(false);
    const [totalBill, setTotalBill] = React.useState();
    const dispatch = useDispatch();
    const [appointment, commitAppointment] = useAppointmentCreator();
    const notify = useNotify();
    console.log("mentorDetails", mentorDetails);

    const handleSubmit = () => {
      try {
        commitAppointment(totalBill);
        // dispatch(fetchStart());
        // const PaymentDetails = await Parse.Cloud.run("CreateAppointment", {
        //   totalAmount: JSON.stringify(totalBill),
        // });

        // if (PaymentDetails) {
        //   setLoaded(false);
        //   setOpen(false)
        //   dispatch(fetchEnd());
        //   console.log("PaymentDetails",PaymentDetails)
        //   notify(PaymentDetails)
        // } else {
        //   dispatch(fetchEnd());
        //   setLoaded(false);
        // }
      } catch (e) {
        notify("Error", e);
        console.log("Error", e);
      } finally {
        dispatch(fetchEnd());
      }
    };
    const handleClickOpen = useCallback(async () => {
      console.log("mentorDetails", mentorDetails);

      try {
        setOpen(true);
        setLoaded(true);
        dispatch(fetchStart());
        const FetchPaymentDetails = await Parse.Cloud.run(
          "CalculateTotalAmount",
          {
            mentorDetails: JSON.stringify(mentorDetails),
          }
        );

        if (FetchPaymentDetails) {
          dispatch(fetchEnd());
          setLoaded(false);
          setTotalBill(FetchPaymentDetails);
        } else {
          dispatch(fetchEnd());
          setLoaded(false);
        }
      } catch (e) {
        notify("Error", e);
        console.log("Error", e);
      } finally {
        dispatch(fetchEnd());
      }
    }, [notify, dispatch]);

    const handleClose = () => {
      setOpen(false);
    };

    if (appointment.data) {
      // notify("Appointment created successfully");
      // redirect("/");
    }
    console.log("totalBill", totalBill);
    return (
      <div>
        <Dialog
          onClose={handleClose}
          aria-labelledby="simple-dialog-title"
          open={open}
        >
          <DialogTitle id="simple-dialog-title">Final Amount</DialogTitle>
          {loading ? (
            <Loading />
          ) : (
            <DialogContent>
              <Grid container direction="column" spacing={2}>
                <Grid
                  item
                  style={{
                    display: "flex",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    Mentor Fee:-
                  </Typography>
                  &nbsp;&nbsp;
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "right",
                    }}
                  >
                    {mentorDetails.mentorFee}
                  </Typography>
                </Grid>
                <Grid
                  item
                  style={{
                    display: "flex",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    Slot processing fee:-
                  </Typography>
                  &nbsp;&nbsp;
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "right",
                    }}
                  >
                    {totalBill !== undefined ? totalBill.ProcessingFee : ""}
                  </Typography>
                </Grid>
                <Divider />
                {/* <Grid
                    item
                    style={{
                      display: "flex",
                    }}
                  >
                    <Typography>
                    {totalBill !== undefined ? totalBill.ProcessingFee : ""}
                  </Typography>
                </Grid> */}
                <Divider />
                <Grid
                  item
                  style={{
                    display: "flex",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    GST(18%):-
                  </Typography>
                  &nbsp;&nbsp;
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "right",
                    }}
                  >
                    {totalBill !== undefined ? totalBill.MainGST : ""}
                  </Typography>
                </Grid>
                <Divider />
                <Grid
                  item
                  style={{
                    display: "flex",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "left",
                    }}
                  >
                    Total Amount:-
                  </Typography>
                  &nbsp;&nbsp;
                  <Typography
                    variant="body1"
                    style={{
                      textAlign: "right",
                    }}
                  >
                    {totalBill !== undefined ? totalBill.TotalAmount : ""}
                  </Typography>
                </Grid>
              </Grid>
            </DialogContent>
          )}
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              CANCEL
            </Button>
            <Button onClick={handleSubmit} color="primary" autoFocus>
              {"MAKE PAYMENT"}
            </Button>
          </DialogActions>
        </Dialog>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClickOpen}
          className={classes.button}
          // disabled={meeting.loading}
        >
          CONFIRM
        </Button>
      </div>
    );
  };
  return (
    <AppProvider>
      <div
        style={{
          float: "left",
        }}
      >
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((label, index) => (
            <Step key={label}>
              <StepLabel>{label}</StepLabel>
              <StepContent>
                {getStepContent(index, aid, uid)}
                <div className={classes.actionsContainer}>
                  <div>
                    {activeStep !== steps.length - 1 ? (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                      >
                        NEXT
                      </Button>
                    ) : (
                      <React.Fragment>
                        <MakePaymentButton />
                        <Button
                          onClick={handleReset}
                          className={classes.button}
                        >
                          RESET
                        </Button>
                      </React.Fragment>
                    )}
                  </div>
                </div>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </div>
      <div
        style={{
          float: "right",
        }}
      >
        {offer !== undefined ? (
          <Card className={isDesktop ? classes.card : classes.cardSm}>
            <CardActionArea>
              <CardMedia
                title="Offering 1"
                image={offer.offerImage ? offer.offerImage._url : ""}
                className={
                  isDesktop ? classes.cardImage : classes.cardImageSm
                }
                           />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  {offer.offerTitle}
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Charges - Rs 100 / 30 mins
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        ) : (
          ""
        )}
      </div>
    </AppProvider>
  );
}
